// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1aTNT","content":"LayoutSettings_content__2M_Si"};